module.exports = __webpack_public_path__ + "static/media/User.bab1186b.svg";